{
  "WALLBOARD": {
    "LOADING": "Caricamento code telefoniche...",
    "NO_QUEUES": "Nessuna coda telefonica trovata.",
    "AGENTS": "Agenti",
    "NO_AGENTS": "Nessun agente online in questa coda.",
    "NO_AGENTS_ONLINE": "Nessun agente online.",
    "WAITING_CALLERS": "Chiamanti in attesa",
    "NO_CALLERS": "Nessun chiamante in attesa.",
    "UNKNOWN_CALLER": "Chiamante sconosciuto",
    "POSITION": "Posizione",
    "STATUS": "Stato",
    "TIME": "Tempo",
    "AGENT": "Agente",
    "EXTENSION": "Interno",
    "AVAILABLE": "Disponibile",
    "READY": "Agenti pronti",
    "ON_CALL": "Agenti in chiamata",
    "QUEUE_CALL": "Chiamata in coda",
    "OTHER_CALL": "Altra chiamata",
    "PAUSED": "Agenti in pausa",
    "WAITING": "Chiamate in attesa",
    "MISSED_CALLS": "Chiamate perse",
    "HANDLED_CALLS": "Chiamate in entrata gestite",
    "OUTBOUND_CALLS": "Chiamate in uscita gestite",
    "AVAILABILITY": "Disponibilità",
    "AVAILABILITY_TOOLTIP": "Percentuale di chiamate in entrata a cui gli agenti hanno risposto (chiamate prese in carico)",
    "TOTAL": "totale",
    "AGENTS_COUNT": "({onCall} in chiamata / {total} totale)",
    "NO_AVAILABLE": "(nessuno online)",
    "WAITING_CALLERS_COUNT": "{count} in attesa",
    "CALLER": "Chiamante",
    "NUMBER": "Numero",
    "WAIT_TIME": "Tempo di attesa",
    "QUEUES": "Code",
    "ACTION": "Azione",
    "PICKUP_CALL": "Rispondi",
    "PICKING_UP": "Risposta in corso...",
    "PICKUP_SUCCESS": "Richiesta di risposta alla chiamata inviata con successo.",
    "PICKUP_ERROR": "Impossibile rispondere alla chiamata. Riprova.",
    "PICKUP_DISABLED_TOOLTIP": "Non puoi rispondere a una chiamata mentre sei in chiamata o offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Nessun accesso"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Nessun accesso"
    }
  }
}
